import type React from 'react';
import { lazy } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router';

import AppProvider from './providers/app.provider';
import Layout from './providers/layout';
import ProtectedRoute from './providers/protected-route';
import { ROUTES } from './shared/constants';
import NotFound from './shared/widgets/errors/404';

const AutoCreditOrder = lazy(
  () => import('./pages/AutoCreditOrder/auto-credit-order')
);
const AutoCreditOffers = lazy(
  () => import('./pages/AutoCreditOffers/auto-credit-offers')
);
const AutoCreditRequests = lazy(
  () => import('./pages/AutoCreditRequests/auto-credit-requests')
);

const router = createBrowserRouter([
  {
    path: '/',
    element: <AppProvider />,
    children: [
      {
        path: '/:lang',
        children: [
          {
            element: <Layout />,
            children: [
              {
                path: ROUTES.create,
                element: <AutoCreditOrder />
              },
              {
                element: <ProtectedRoute />,
                children: [
                  {
                    path: ROUTES.myOrders,
                    element: <AutoCreditRequests />
                  },
                  {
                    path: ROUTES.myOrdersDetail(),
                    element: <AutoCreditOffers />
                  }
                ]
              },
              {
                path: '*',
                element: (
                  <div className="app-router-not-found">
                    <NotFound />
                  </div>
                )
              }
            ]
          }
        ]
      }
    ]
  }
]);

const App: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default App;
